import emailjs from "@emailjs/browser";

export const emailjsSend = async (contact: any, templateID: string) => {
	try {
		await emailjs.send(process.env.NEXT_PUBLIC_EMAILJS_SERVICEID ?? "", templateID, contact, process.env.NEXT_PUBLIC_EMAILJS_USERID);
		return true;
	} catch (err) {
		return false;
	}
};
